import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PatientComponent } from '@modules/cy/patient/pages/patient/patient.component';
import { physicianGuard } from '@app/auth/guards/physician.guard';
import { CYComponent } from '@modules/cy/pages/cy/cy.component';
import { PatientMenuComponent } from '@modules/cy/patient/ps/pages/patient-menu/patient-menu.component';
import { CreateEditRoutes } from '@modules/cy/patient/ps/create-edit/create-edit-routing.module';
import { CreateRoutes } from '@modules/cy/patient/orcd/create/create-routing.module';
import { PatientSummaryComponent } from '@modules/cy/patient/ps/pages/patient-summary/patient-summary.component';
import { EprescriptionComponent } from '@modules/cy/patient/ep/pages/eprescription/eprescription.component';
import { OrcdComponent } from '@modules/cy/patient/orcd/pages/orcd/orcd.component';
import { VaccinationsCardComponent } from '@modules/cy/patient/euvac/pages/vaccinations-card/vaccinations-card.component';

export const PSroutes: Routes = [
  {
    path: '',
    component: PatientMenuComponent,
    canActivate: [physicianGuard],
  },
  {
    path: 'ps',
    component: PatientSummaryComponent,
    canActivate: [physicianGuard],
    children: CreateEditRoutes,
  },
  {
    path: 'ep',
    component: EprescriptionComponent,
    canActivate: [physicianGuard],
  },
  {
    path: 'orcd',
    component: OrcdComponent,
    canActivate: [physicianGuard],
    children: CreateRoutes,
  },
  {
    path: 'euVac',
    component: VaccinationsCardComponent,
    canActivate: [physicianGuard],
  },
  {
    path: '**',
    redirectTo: '/cy',
  },
];

@NgModule({
  imports: [RouterModule.forChild(PSroutes)],
  exports: [RouterModule],
})
export class PsRoutingModule {}
